export default __webpack_public_path__ + "static/media/1v1_platinum_header.9bbab914.png";